import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=761110de"
import script from "./DashboardTable.vue?vue&type=script&lang=ts"
export * from "./DashboardTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports